document.addEventListener("DOMContentLoaded", () => {
  // 针对每个 section 初始化轮播
  document.querySelectorAll('.kickstarter-scroll-switch').forEach((section, index) => {
    let currentIndex = 0;
    let canSwitch = true;
    const slides = section.querySelectorAll('.tab-item');
    // 切换函数
    function showSlide(index) {
      section.querySelector(`.tab-item[target-id="${index}"]`)?.click();
    }
    // 处理滚轮事件
    function handleWheel(e) {
      e.preventDefault(); // 阻止页面默认滚动
      if (!canSwitch) return;

      const direction = e.deltaY > 0 ? 'down' : 'up';

      if (direction === 'down' && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (direction === 'up' && currentIndex > 0) {
        currentIndex--;
      } else {
        window.removeEventListener('wheel', handleWheel);
        if (currentIndex >= slides.length - 1) {currentIndex = slides.length;}
        if (currentIndex <= 0) {currentIndex = 0;}
      }
      showSlide(currentIndex);

      canSwitch = false;
      setTimeout(() => (canSwitch = true), 900); // 防抖
    }
    function initDesktopScroll() {
      // 监听页面滚轮
      window.addEventListener('wheel', handleWheel, { passive: false });
    }

    // 初始化移动端slick
    function initMobileSlick(slider) {
      slider.slick({
        infinite: true,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: true,
        prevArrow: `<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="kss-prev-${index}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="kss-prev-${index}">Prev Item</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>`,
        nextArrow: `<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="kss-next-${index}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="kss-next-${index}">Next Item</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>`,
        dots: true,
      });
    }

    function initFeatureSection(slider) {
      if (window.innerWidth > 749) {
        // 桌面模式
        if(slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        // initDesktopScroll();
      } else {
        // 移动模式
        // window.removeEventListener('scroll', handleScroll);
        initMobileSlick(slider);
      }
    }

    // Init Tabs Event (PC)
    let tabBox = section.querySelector('.tab-box');
    $(tabBox).off('click', '.tab-item').on('click', '.tab-item', function() {
      let tabId = $(this).attr('target-id');
      currentIndex = tabId;
      let $selfDesc = $(this).find('.item-desc');
      // 切换按钮样式
      // 1 - 先关闭所有的 accordion
      $(this).siblings('.active').find('.item-desc').slideToggle();
      $(this).siblings().removeClass('active');
      // 2 - 再打开当前点击的 accordion
      if ($selfDesc.is(':hidden')) {
        $selfDesc.slideToggle();
        $(this).addClass('active');
      }
      // 3 - 切换对应的图片
      $(section).find('.tab-panel').removeClass('active');
      $(section).find(`.tab-panel[data-index="${tabId}"]`).addClass('active');
    });

    let tabContentBox = $(section.querySelector('.tab-content-box'));
    initFeatureSection(tabContentBox);
    window.addEventListener('resize', () => {
      // 监听宽度变化切换模式
      initFeatureSection(tabContentBox);
    });

    // IntersectionObserver 控制初始化
    // const observer = new IntersectionObserver(entries => {
    //   entries.forEach(entry => {
    //     if (entry.isIntersecting) {
    //       initDesktopScroll();
    //     } else {
    //       window.removeEventListener('scroll', handleWheel);
    //     }
    //   });
    // }, { threshold: 0.8 });
    // observer.observe(section);
  });
});

// IntersectionObserver 控制初始化
// const observer = new IntersectionObserver(entries => {
//   entries.forEach(entry => {
//     if (entry.isIntersecting) {
//       let parentEl = entry.target;

//       // Init Tabs Event (PC)
//       let tabBox = parentEl.querySelector('.tab-box');
//       $(tabBox).off('click', '.tab-item').on('click', '.tab-item', function() {
//         let tabId = $(this).attr('target-id');
//         let $selfDesc = $(this).find('.item-desc');
//         // 切换按钮样式
//         // 1 - 先关闭所有的 accordion
//         $(this).siblings('.active').find('.item-desc').slideToggle();
//         $(this).siblings().removeClass('active');
//         // 2 - 再打开当前点击的 accordion
//         if ($selfDesc.is(':hidden')) {
//           $selfDesc.slideToggle();
//           $(this).addClass('active');
//         }
//         // 3 - 切换对应的图片
//         $(parentEl).find('.tab-panel').removeClass('active');
//         $(parentEl).find(`.tab-panel[data-index="${tabId}"]`).addClass('active');
//       });

//       let tabContentBox = $(parentEl.querySelector('.tab-content-box'));
//       initFeatureSection(tabContentBox);
//       window.addEventListener('resize', () => {
//         // 监听宽度变化切换模式
//         initFeatureSection(tabContentBox);
//       });

//       observer.unobserve(parentEl); // 只执行一次
//     }
//   });
// }, { threshold: 0.3 });

// observer.observe(section);
